var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDrilldown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-339 415 18 12",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-338.2 418.2c0-.3.1-.6.3-.8.5-.5 1.2-.5 1.7 0l5.5 5.5 5.6-5.6c.5-.5 1.2-.5 1.7 0s.5 1.2 0 1.7l-6.4 6.4c-.5.5-1.2.5-1.7 0l-6.3-6.4c-.3-.2-.4-.5-.4-.8z"
  })));
}

export default SvgDrilldown;